import { GatsbyBrowser } from "gatsby";
import { FavIcon } from "./src/components/dato/site/FavIcon";
import Layout, { LayoutProps } from "./src/components/layout/layout";
import { LocationProvider } from "./src/context/LocationContext";
import { PageContext, PageContextState } from "./src/context/page-context";

export const wrapRootElement: GatsbyBrowser["wrapRootElement"] = ({
  element,
}) => <>{element}</>;

export const wrapPageElement: GatsbyBrowser<
  LayoutProps,
  PageContextState
>["wrapPageElement"] = ({ element, props }) => (
  <PageContext.Provider value={props.pageContext}>
    <LocationProvider location={props.location}>
      <FavIcon />
      <Layout {...props.data}>{element}</Layout>
    </LocationProvider>
  </PageContext.Provider>
);
